import React from 'react';
import PropTypes from 'prop-types';

import { IComponent } from '../../../typings/generic-component';
import { makeClassNames, IClassNames } from '../../../utils/styles';
import './outlined-card.scss';

export interface IOutlinedCard extends IComponent {
  footer?: React.ReactNode;
  header?: React.ReactNode;
}

const classNames = (): IClassNames =>
  makeClassNames({
    root: 'outlined-card',
    footer: 'outlined-card__footer',
    header: 'outlined-card__header',
  });

const OutlinedCard: React.FC<IOutlinedCard> = ({ children, footer, header }) => {
  const cn = classNames();

  return (
    <div className={cn.root}>
      {header && <div className={cn.header}>{header}</div>}
      {children}
      {footer && <div className={cn.footer}>{footer}</div>}
    </div>
  );
};

/* istanbul ignore else */ if (process.env.NODE_ENV !== 'production') {
  OutlinedCard.propTypes = {
    children: PropTypes.node.isRequired,
    footer: PropTypes.node,
    header: PropTypes.node,
  };
}

export default OutlinedCard;
